import { render } from "./Nintendo.vue?vue&type=template&id=90b17e2a"
import script from "./Nintendo.vue?vue&type=script&lang=js"
export * from "./Nintendo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__